import _get from 'lodash/get';
import _uniq from 'lodash/uniq';
import _uniqBy from 'lodash/uniqBy';
import _sortBy from 'lodash/sortBy';

export const getDoughTypes = variations => {
  const newVariations = variations.map(variant => {
    return variant.kind !== null
      ? {
          id: variant.kind.id,
          label: variant.dough,
        }
      : null;
  });

  const uniqTypes = _uniqBy(newVariations, 'label');

  return _sortBy(uniqTypes, 'label').reverse();
};

export const getVariationsByDoughPizza = (variations, doughId) => {
  const variationsWithKindId = variations.filter(variant => variant.kind !== null);

  return variationsWithKindId.filter(variant => variant.kind.id === Number(doughId));
};

export const getVariationsByDough = (variations, dough) => {
  return variations.filter(variant => variant.dough === dough);
};

export const getSizes = variations => {
  const uniqSizes = _uniqBy(
    variations.map(variant => variant.size),
    'value',
  );

  return _sortBy(uniqSizes, 'value').filter(Boolean);
};

export const getStuffedCrusts = (variations, size) => {
  return _uniq(
    variations
      .filter(variant => variant.size?.value === Number(size))
      .map(variant => variant.stuffed_crust),
  );
};

export const getVariation = (variations, sizeValue, stuffedCrust = 'none') => {
  const result = variations.find(
    variant =>
      variant.size?.value === Number(sizeValue) &&
      (!variant.stuffed_crust || variant.stuffed_crust === stuffedCrust),
  );

  return result || variations[0] || {};
};

// доступно ли чтото кроме стандартного
export const stuffedCrustIsAvailable = (variations, size) => {
  return Boolean(
    variations.find(
      variant => variant.stuffed_crust !== 'none' && variant.size.value === Number(size),
    ),
  );
};

// доступно ли чтото при этом стандартное остуствует
export const onlyStuffedCrustIsAvailable = (variations, size) => {
  const crustIsAvailable = stuffedCrustIsAvailable(variations, size);

  return (
    crustIsAvailable &&
    !variations.find(
      variant => variant.stuffed_crust === 'none' && _get(variant, 'size.value') === Number(size),
    )
  );
};

export const stuffedCrustsAvailableDefaultSort = (variations, sizeValue) => {
  return _uniq(
    variations
      .filter(variant => variant.size?.value === Number(sizeValue))
      .map(variant => variant.stuffed_crust),
  );
};

function sortCrusts(stuffed_crust, stuffed_crust_second) {
  if (stuffed_crust === 'none') {
    return 1;
  }

  if (stuffed_crust_second === 'none') {
    return -1;
  }

  if (stuffed_crust === 'cheese' && stuffed_crust_second === 'sausage') {
    return 1;
  }

  if (stuffed_crust === 'sausage' && stuffed_crust_second === 'cheese') {
    return -1;
  }

  return 0;
}

export const stuffedCrustsAvailable = (variations, size) => {
  return stuffedCrustsAvailableDefaultSort(variations, size).sort(sortCrusts);
};

export const getPersonCount = variation => {
  const characteristics = variation?.characteristics || [];
  const characteristic = characteristics.find(char => char.code === 'per_person');

  return characteristic?.value || '';
};

export const getRemovedIngredientsCount = variation => {
  const includeIngredients = variation?.include_ingredients || [];

  return includeIngredients
    .filter(item => item.removed)
    .reduce((acc, item) => acc + Number(item.count), 0);
};
